import React from 'react';
import Form from 'react-bootstrap/Form';

import Util from '../../../util/Util';
import Const from '../../../util/Constants';

class PermissionAUD extends React.Component {

  constructor(props) {
    super(props);
    const permission = props.role[props.module];
    const binary = Util.decimalToBinary(permission);
    this.state = { perm: [false, false, false, false] };
    for(let j = binary.length - 1, i = 0; j >= 0 ; j--, i++) {
      this.state.perm[i] = parseInt(binary[j]) === Const.True;
    }
  }

  change = (val, index) => {
    let perm = [...this.state.perm];
    perm[index] = val;
    let binary = '';
    for(let i = perm.length -1; i >= 0 ; i--) binary += ( perm[i] ? Const.True : Const.False );
    this.props.change(this.props.module, Util.binaryToDecimal(binary));
    this.setState({ ...this.state, perm});
  }
  
  render() {
    return (
      <>
        <span className="paddr">
          <Form.Check
            onChange={ event => this.change(event.target.checked, Const.PermView) }
            checked={ this.state.perm[Const.PermView] } />
            View
        </span>
        <span className="paddr">
          <Form.Check
            onChange={ event => this.change(event.target.checked, Const.PermAdd) }
            checked={ this.state.perm[Const.PermAdd] } />
            Add
          </span>
        <span className="paddr">
          <Form.Check
            onChange={event => this.change(event.target.checked, Const.PermUpdate)}
            checked={this.state.perm[Const.PermUpdate]} />
          Update
        </span>
        <span className="paddr">
          <Form.Check
            onChange={event => this.change(event.target.checked, Const.PermDelete)}
            checked={this.state.perm[Const.PermDelete]} />
          Delete
        </span>
        <span className="paddr">
          <Form.Check
            onChange={event => this.change(event.target.checked, Const.PermRestricAcc)}
            checked={this.state.perm[Const.PermRestricAcc]} />
          Restrict Access
        </span>
        <span className="paddr">
          <Form.Check
            onChange={event => this.change(event.target.checked, Const.PermAllowPermission)}
            checked={this.state.perm[Const.PermAllowPermission]} />
          Allow Permission
        </span>
      </>
    );
  }
}
export default PermissionAUD;